import { render, staticRenderFns } from "./TlcReports.vue?vue&type=template&id=3457e583"
import script from "./TlcReports.vue?vue&type=script&lang=js"
export * from "./TlcReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports